import React, { useCallback, useState, useRef } from "react";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUpload,
  faTimes,
  faCheckCircle,
  faEye,
  faTrashAlt,
  faEyeSlash,
} from "@fortawesome/pro-light-svg-icons";
import { useDeepEffect } from "../../abstracts";
import { get } from "lodash";
import AddToolTip from "../AddToolTip";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const UploadComponentLoans = (props) => {
  const {
    setFieldValue,
    label,
    name,
    values,
    clearUploadFile,
    setFileUploadRequired,
    setNewFile,
    clearField,
    setClearField,
    setShowFileName,
    fileExtensions,
    fieldName = "uploadSourceFile",
    setDocumentHidden,
    documentHidden,
  } = props;
  const inputFileRef = useRef();
  const [myFiles, setMyFiles] = useState(get(values, fieldName, []));
  const [isUploadSuccess, setIsUploadSuccess] = useState(true);
  const [edit, setEdit] = useState(false);
  const file = get(values, `${name}.0`);
  const [reUpload, setReUpload] = useState(true);
  let size =
    (file?.size / 1024).toFixed(2) > 1000
      ? `${(file?.size / 1024 / 1024).toFixed(2)} MB`
      : `${(file?.size / 1024).toFixed(2)} KB`;

  function getBlobURL() {
    return URL.createObjectURL(myFiles[0]);
  }
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (myFiles.length === 0) {
        setMyFiles([...myFiles, ...acceptedFiles]);
        setFieldValue(name, acceptedFiles);
        if (setNewFile) {
          setNewFile(name, acceptedFiles);
        }
      }
      if (acceptedFiles.length === 0) {
        setIsUploadSuccess(false);
      } else {
        setIsUploadSuccess(true);
      }
    },
    [myFiles]
  );
  useDeepEffect(() => {
    if (clearField) {
      setMyFiles([]);
      setClearField(false);
      setShowFileName(true);
    }
  }, [clearField]);

  // useDeepEffect(() => {
  //   setEdit(true);
  //   setMyFiles([get(values, fieldName, [])]);
  // }, [values]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: fileExtensions,
  });

  const removeFile = (file) => () => {
    const newFiles = [...myFiles];
    if (setFileUploadRequired) {
      setFileUploadRequired("");
    }
    const ind = newFiles.indexOf(file);
    newFiles.splice(ind, 1);
    setMyFiles(newFiles);
    setFieldValue(name, [{ deleted: true }]);
    if (clearUploadFile) {
      clearUploadFile();
    }
    if (setNewFile) {
      setNewFile([]);
      setFieldValue(name, undefined);
      setShowFileName(true);
    }
  };

  const files = myFiles.map((file) => (
    <div
      className="d-flex"
      style={{
        justifyContent: "flex-start",
        fontSize: "16px",
        fontWeight: "500",
        marginRight: "130px",
      }}
    >
      <span
        style={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          width: "80%",
          whiteSpace: "nowrap",
        }}
      >
        {!file.lastModified ? (
          file.fileName
        ) : (
          <AddToolTip style={{}} name={file.path}>
            {(file.path || "").slice(0, 15)}...
          </AddToolTip>
        )}
      </span>
      <span
        className="ml-4"
        style={{ cursor: "pointer", zIndex: 100 }}
        onClick={removeFile(file)}
      >
        <FontAwesomeIcon
          icon={faTrashAlt}
          color={"#ff0000"}
          onClick={() => setFieldValue(name, undefined)}
        />
      </span>
    </div>
  ));

  const getClassName = isUploadSuccess
    ? "upload-docs border-color-normal"
    : "upload-docs border-color-red";
  return (
    <div>
      <label className="label-text">{label}</label>
      <input
        name={name}
        {...getInputProps()}
        disabled={myFiles?.length && reUpload}
      />
      <div
        className={getClassName + " p-3"}
        style={{
          borderRadius: "0px 10px 10px 0px",
          position: "relative",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          id={`dropZone${fieldName}`}
          ref={inputFileRef}
          className="dropZone"
          style={{
            position: "absolute",
            justifyContent: "center",
            height: "80%",
            width: "65%",
          }}
          {...getRootProps({ className: "dropzone" })}
        ></div>
        {get(values, name, []).length === 0 ||
        get(values, name, [])?.[0]?.deleted ? (
          <>
            {/* <div className="dropZone" style={{ display: "flex", justifyContent: "center" }} {...getRootProps({ className: "dropzone" })}> */}

            <div style={{ width: "fit-content" }}>
              <FontAwesomeIcon icon={faUpload} />
              <p> Drag & Drop Here</p>
              <p> or</p>
              <p className="link-text"> Browse file</p>
            </div>
            {/* </div> */}
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                width: "100%",
              }}
            >
              {files}
              <div className="d-flex">
                <div style={{ color: "#777777", marginRight: "15px" }}>
                  {size}
                </div>{" "}
                |{" "}
                <div
                  style={{
                    cursor: "pointer",
                    color: "#2F80ED",
                    marginLeft: "15px",
                    zIndex: "100",
                  }}
                  onClick={async () => {
                    setReUpload(false);
                    setMyFiles([]);
                    setFieldValue(name, undefined);
                    let elementToBeClicked = await document.getElementById(
                      `dropZone${fieldName}`
                    );
                    elementToBeClicked.click();
                  }}
                >
                  Reupload
                </div>
              </div>

              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: "12px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      color={"#1C7E18"}
                      className="mr-2"
                    />
                    <div style={{ color: "#1C7E18" }}>
                      Successfully Uploaded{" "}
                    </div>
                  </div>

                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={() => setDocumentHidden(!documentHidden)}
                  >
                    <FontAwesomeIcon
                      icon={documentHidden ? faEye : faEyeSlash}
                      color={"#2F80ED"}
                      className="mr-2"
                    />
                    <div style={{ color: "#2F80ED", cursor: "pointer" }}>
                      {" "}
                      {documentHidden ? "Preview" : "Hide"}{" "}
                    </div>
                  </div>
                </div>
              </>
            </div>
            <div></div>
          </>
        )}
      </div>
      {/* <span className="file-type">Accepted File Type : {fileExtensions}</span> */}
      <p className="file-type-red">
        {!isUploadSuccess ? "*Please upload a valid file" : <></>}
      </p>
    </div>
  );
};

export default UploadComponentLoans;
